class CartOpen extends HTMLElement {
  constructor() {
    super();
    document.addEventListener(
      "DOMContentLoaded",
      () => {
        document.addEventListener("click", (e) => {
          const b = e.target.closest("button");
          if (b && b.matches(".site-header__cart")) {
            this.openCart();
          }
        });
      },
      false
    );
  }

  openCart() {
    document.querySelector(".flyout").classList.add("active");
    document.body.style.overflow = "hidden";
  }
}

customElements.define("cart-open", CartOpen);

class SiteCart extends HTMLElement {
  constructor() {
    super();
    this.note = undefined;
    this.form = this.querySelector("form");
    this.gift = this.querySelector(".cart__gift-note");
    this.cont = this.querySelector(".cart__container");
    this.trigger = this.querySelector(".cart__gift-trigger");
    this.previewCont = this.querySelector(".cart__gift-preview-cont");
    this.previewText = this.querySelector(".cart__gift-preview-text");
    this.textarea = this.querySelector(".cart__gift-textarea");
    this.charCount = this.querySelector(".cart__gift-char");
    this.initFetchNote();
    this.initClickEvents();
    this.initInputEvent();
  }

  async initFetchNote() {
    const resp = await fetch("/cart.js");
    const data = await resp.json();
    if (data && data.note) {
      this.updateNoteUI(data.note);
    }
  }

  updateNoteUI(note) {
    this.note = note;
    this.textarea.value = note;
    this.previewText.innerHTML = note;
    this.openPreview();
  }

  openPreview() {
    this.previewCont.classList.add("active");
    this.trigger.classList.remove("active");
  }
  closePreview() {
    this.previewCont.classList.remove("active");
    this.trigger.classList.add("active");
  }

  initClickEvents() {
    document.addEventListener("click", async (e) => {
      const t = e.target;
      const b = t.closest("button");
      if (
        (b && b.matches(".flyout__veil")) ||
        (b && b.matches(".flyout__close"))
      ) {
        e.preventDefault();
        t.closest(".flyout").classList.remove("active");
        document.body.removeAttribute("style");
      }
      if (b && b.matches(".cart__gift-trigger")) {
        this.openGiftNote();
      }
      if (t.matches(".cart__gift-cancel")) {
        this.closeGiftNote();
      }
      if (t.matches(".cart__gift-save")) {
        await this.saveGiftNote(this.textarea.value);
        this.updateNoteUI(this.note);
        this.closeGiftNote();
      }
      if (t.matches(".cart__gift-edit")) {
        this.openGiftNote();
      }
      if (t.matches(".cart__gift-remove")) {
        await this.saveGiftNote("");
        this.closePreview();
      }
    });
  }
  initInputEvent() {
    this.textarea.addEventListener("input", (e) => {
      this.charCount.innerHTML = e.target.value.length + 0;
    });
  }
  async saveGiftNote(note) {
    const resp = await fetch("/cart/update.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ note }),
    });
    const data = await resp.json();
    this.note = data.note;
  }

  openGiftNote() {
    this.cont.classList.remove("active");
    this.gift.classList.add("active");
    this.textarea.focus();
  }
  closeGiftNote() {
    this.cont.classList.add("active");
    this.gift.classList.remove("active");
  }
}

customElements.define("site-cart", SiteCart);

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      this.closest("cart-items").updateQuantity(
        this.dataset.index,
        0,
        event.target.dataset.boxId
      );
    });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById(
      "shopping-cart-line-item-status"
    );

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );

    this.updateCustomBoxTitles();

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener("change", this.debouncedOnChange.bind(this));
  }

  updateCustomBoxTitles() {
    Array.from(document.querySelectorAll("[class^='name-']")).forEach(
      (title) => {
        const id = title.classList[0].split("-")[1];
        const box = localStorage.getItem(`bift-box-${id}`);
        const data = JSON.parse(box);
        if (data && data.occasion) {
          const fmtOccasion = data.occasion
            .split("-")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ");
          title.innerHTML = `Custom ${fmtOccasion} box`;
        } else {
          title.innerHTML = `Custom box`;
        }
      }
    );
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      event.target.dataset.boxId
    );
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: "main-cart-items",
        selector: "#main-cart-items",
      },
      {
        id: "main-cart-footer",
        section: "main-cart-footer",
        selector: "#main-cart-footer",
      },
      {
        id: "main-cart-header",
        section: "main-cart-header",
        selector: "#main-cart-header",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: "#cart-icon-bubble",
      },
    ];
  }

  renderCartSections(result) {
    this.getSectionsToRender().forEach((section) => {
      const elToReplace = document.querySelector(section.selector);
      const footer = document.getElementById("main-cart-footer");
      if (elToReplace) {
        elToReplace.innerHTML = this.getSectionInnerHTML(
          result.sections[section.section],
          section.selector
        );

        if (section.id === "main-cart-header") {
          document
            .querySelector(".cart__close.flyout__close")
            .addEventListener("click", function () {
              document.querySelector(".flyout").classList.remove("active");
            });
        }

        if (result.items.length > 0) {
          this.classList.remove("is-empty");
          footer.classList.remove("is-empty");
        } else {
          this.classList.add("is-empty");
          footer.classList.add("is-empty");
        }
      }
    });
    this.updateCustomBoxTitles();
  }

  async updateQuantity(line, quantity, boxId) {
    this.enableLoading(line);

    const onSuccess = (result) => {
      this.renderCartSections(result);
      this.disableLoading();
    };

    const onError = () => {
      this.disableLoading();
    };

    const config = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: `application/json`,
      },
    };

    if (boxId) {
      const resp = await fetch("/cart.js");
      const data = await resp.json();
      fetch("/cart/update.js", {
        ...config,
        body: JSON.stringify({
          updates: data.items
            .filter((item) => item.properties.Box === boxId)
            .reduce(
              (acc, item) => ({ ...acc, [item.variant_id]: quantity }),
              {}
            ),
          sections: this.getSectionsToRender().map(
            (section) => section.section
          ),
        }),
      })
        .then((response) => response.json())
        .then((result) => {
          onSuccess(result);
        })
        .catch((error) => {
          onError();
        });
    } else {
      fetch("/cart/change", {
        ...config,
        body: JSON.stringify({
          line,
          quantity,
          sections: this.getSectionsToRender().map(
            (section) => section.section
          ),
        }),
      })
        .then((response) => response.json())
        .then((result) => {
          onSuccess(result);
        })
        .catch(() => {
          onError();
        });
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    document
      .getElementById("main-cart-items")
      .classList.add("cart__items--disabled");
    this.querySelectorAll(`#CartItem-${line} .loading-overlay`).forEach(
      (overlay) => overlay.classList.add("active")
    );
  }

  disableLoading() {
    document
      .getElementById("main-cart-items")
      .classList.remove("cart__items--disabled");
    this.querySelectorAll(".loading-overlay").forEach((overlay) =>
      overlay.classList.remove("active")
    );
  }
}

customElements.define("cart-items", CartItems);
